import { compKey } from './key';
export var createSettingsContainerSectionDriver = function (wrapper, immediate) {
    if (immediate === void 0) { immediate = false; }
    var base = immediate ? wrapper : wrapper.$("." + compKey);
    return {
        getTitle: function () { return base.$('.title').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map